import { Trait } from "types";
import * as traitsApi from "api/traitsApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchTraits = (address?: string) =>
  useFetchPromise<Trait[], string | undefined>(traitsApi.fetchTraits, address);

export default useFetchTraits;
